import { Controller } from 'stimulus';
import debounce from '@/helpers/debounce';

class FilterSearchController extends Controller {
  connect() {
    this.searchDebounced = debounce((search) => {
      this.searchList(search.length > 2 ? search : '');
    }, 200);

    if (this.hasListTarget) {
      this.listTarget.addEventListener('scroll', this.onListScroll.bind(this));
    }
  }

  disconnect() {
    if (this.hasListTarget) {
      this.listTarget.removeEventListener('scroll', this.onListScroll.bind(this));
    }
  }

  onInputKeyup(e) {
    this.searchDebounced(e.currentTarget.value);
  }

  onListScroll() {
    const { scrollHeight, scrollTop, clientHeight } = this.listTarget;
    const isAtBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 1;

    this.element.classList.toggle('is-at-bottom', isAtBottom);
  }

  searchList(search) {
    const normalizedSearch = this.normalizeSearch(search);

    this.itemTargets.forEach((item) => {
      if (search === '') {
        item.style.display = 'block';
        return;
      }

      const inTitle = this.normalizeSearch(item.dataset.title).indexOf(normalizedSearch) >= 0;

      item.style.display = inTitle ? 'block' : 'none';
    });
  }

  // eslint-disable-next-line class-methods-use-this
  normalizeSearch(search) {
    return search.toLowerCase().trim().replace(/[\s-]/g, '');
  }
}

FilterSearchController.targets = [
  'item',
  'list',
];

export default FilterSearchController;
